import { useFormik } from "formik";

const useForm = (initialValues, validationSchema, onSubmit = () => {}) => {
  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    onSubmit,
  });

  const {
    isValid,
    values,
    resetForm,
    isSubmitting,
    setSubmitting,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
  } = formik;

  return {
    isValid,
    values,
    resetForm,
    isSubmitting,
    setSubmitting,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
  };
};

export default useForm;
